import { Staff } from 'types';
import { StaffActions } from 'types/store/actions/staff';
import { StaffActionTypes } from 'types/store/actions/constants';
import Pagination from 'sources/sourceTypes/Pagination';

export const listSuccess = (payload: Pagination<Staff>): StaffActions => ({
  type: StaffActionTypes.LIST_SUCCESS,
  payload,
});

export const listAllSuccess = (records: Array<Staff>): StaffActions => ({
  type: StaffActionTypes.LIST_ALL_SUCCESS,
  payload: { records },
});

export const reset = (): StaffActions => ({
  type: StaffActionTypes.RESET,
});
